import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20TV%20screen%20displaying%20vibrant%20colorful%20abstract%20visuals%2C%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20cinematic%20atmosphere%2C%20rich%20dark%20tones%20with%20golden%20highlights&width=1600&height=600&seq=madou-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/60"></div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
          准备好开启高清视听之旅了吗？
        </h2>
        <p className="text-background-50/70 text-sm md:text-base mb-8 max-w-[500px] mx-auto">
          加入麻豆cm传媒在线高清，海量4K资源等你来探索。无需等待，立即开始免费观看！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap transition-all cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-play-circle-fill text-lg"></i>
            立即免费观看
          </Link>
          <Link
            to="/about"
            className="bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap transition-all cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}